import { TypeValueValidation } from "../../models";

type TypeErrorMessage = {
  [key in TypeValueValidation]: string;
};

const error: TypeErrorMessage = {
  empty: "Can't be empty.",
  password: "Password length must have to be at least 6 characters.",
  email: "Invalid email.",
  phone_number: "Invalid phone number.",
  date: "Invalid date.",
  time: "Invalid time.",
  number: "Value is not a number.",
  gender: "Invalid value.",
  yes_no: "Invalid value.",
  unique: "This value already exists.",
  address: "Invalid address.",
  insurance_id: "Invalid insurance Id.",
};

export const Message = { error };
